/** @jsxImportSource @emotion/react */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import PageTitle from "../../../Utils/smsTitle";
import { SubHeader } from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import { useGBVAssessment } from "./hooks/useGBVAssessment";
import { GBVAssessmentForm } from "./GBVAssessmentForm";
import { GBVAssessmentHistory } from "./GBVAssessmentHistory";
import {
    GBVPageWrapper,
    ConfidentialityBanner, ConfidentialityIcon,

    GBVLoading,
} from "./GBVScreeningStyles";
import { ObGynTabBar, ObGynTabBtn, ObGynTabBadge } from "../../Utils/ObGynTabStyles";

/* ═══════════════════════════════════════════════════════════════
   GBVScreeningPage — Main page for Task 20:
   GBV Screening & Management
   Tabs: Assessment | History
   Route: /gyn-and-obs-gbv-screening/:patient_number/:visit_id/:patient_type
   Access: Restricted to authorized GBV focal persons
   ═══════════════════════════════════════════════════════════════ */

const GBVScreeningPage = function (props) {
    const actions = props.actions;
    const snackbar = props.snackbar;
    const params = props.match.params;
    const patient_number = params.patient_number;
    const visit_id = params.visit_id;
    const patient_type = params.patient_type;

    /* ── Hook ── */
    const gbv = useGBVAssessment(actions, patient_number, visit_id);

    const closeSnackbar = function () { actions.snackbarActions.hideSnackbar(); };

    /* ── Loading ── */
    if (gbv.loading) {
        return (
            <div>
                <PageTitle title="GBV Screening & Management" />
                <SubHeader title="OB/GYN" subTitle="GBV Screening & Management" />
                <MainSnackbar variant={snackbar.variant} message={snackbar.message}
                    open={snackbar.open} handleCloseBar={closeSnackbar} />
                <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                    <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} patient_type={patient_type} />
                    <GBVPageWrapper>
                        <GBVLoading>Loading GBV assessment data...</GBVLoading>
                    </GBVPageWrapper>
                </ObGynSidebar>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="GBV Screening & Management" />
            <SubHeader title="OB/GYN" subTitle="GBV Screening & Management" />
            <MainSnackbar variant={snackbar.variant} message={snackbar.message}
                open={snackbar.open} handleCloseBar={closeSnackbar} />
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} patient_type={patient_type} />
                <GBVPageWrapper>


                    {/* ─── Tab Bar ─── */}
                    <ObGynTabBar>
                        <ObGynTabBtn
                            active={gbv.activeTab === "assessment"}
                            onClick={function () { gbv.setActiveTab("assessment"); }}
                        >
                            Assessment
                        </ObGynTabBtn>
                        <ObGynTabBtn
                            active={gbv.activeTab === "history"}
                            onClick={function () { gbv.setActiveTab("history"); }}
                        >
                            History
                            <ObGynTabBadge active={gbv.activeTab === "history"}>
                                {gbv.assessments.length}
                            </ObGynTabBadge>
                        </ObGynTabBtn>
                    </ObGynTabBar>

                    {/* ─── Tab Content ─── */}
                    {gbv.activeTab === "assessment" && (
                        <GBVAssessmentForm gbv={gbv} />
                    )}

                    {gbv.activeTab === "history" && (
                        <GBVAssessmentHistory gbv={gbv} />
                    )}

                </GBVPageWrapper>
            </ObGynSidebar>
        </div>
    );
};

/* ─── Redux Connect ─── */
function mapStateToProps(state) {
    return { snackbar: state.snackbar };
}

function mapDispatchToProps(dispatch) {
    return { actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } };
}

export default connect(mapStateToProps, mapDispatchToProps)(GBVScreeningPage);
